import React from 'react';
import styled from 'styled-components';

/**
 * Componentes estilizados para divisores
 */
const Divider = styled.div`
    position: relative;
    height: 1px;
`;

const DivTransparent = styled(Divider)`
    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 5%;
        right: 5%;
        width: 90%;
        height: 1px;
        background-image: linear-gradient(to right, transparent, rgb(48,49,51), transparent);
    }
`;

const DivArrowDown = styled(DivTransparent)`
    &:after {
        content: '';
        position: absolute;
        z-index: 1;
        top: -6.5px;
        left: calc(25% - 7px);
        width: 14px;
        height: 14px;
        transform: rotate(45deg);
        background-color: white;
        border-bottom: 1px solid rgb(48,49,51);
        border-right: 1px solid rgb(48,49,51);
    }
`;

/**
 * Layout comum para as páginas de gestão de comprovantes.
 * @param {React.Node} children - Componentes filhos a serem renderizados dentro do layout.
 */
function ComprovanteLayout({ children }) {
    return (
        <section className="content">
            <div className="container-fluid" style={{ marginTop: 18 }}>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            {/* Cabeçalho */}
                            <div className="card-header bg-info">
                                <div className="inner text-center">
                                    <img src="/dist/img/martelo.png" alt="Logo" />
                                </div>
                                <h3 className="text-center">Gerenciamento de Comprovantes</h3>
                            </div>
                            {/* Corpo */}
                            <div className="card-body">
                                {children}
                            </div>
                            {/* Fim do corpo */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ComprovanteLayout;